var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "customer-transfers-view" },
    [
      _c(
        "div",
        { staticClass: "customer-transfers-header" },
        [
          _c("h3", [_vm._v(_vm._s(_vm.$t("dos.title")))]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: {
                type: "primary",
                size: "small",
                icon: "el-icon-refresh",
              },
              on: { click: _vm.refresh },
            },
            [_vm._v("\n      " + _vm._s(_vm.$t("dos.refresh")) + "\n    ")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("filter-panel", {
        on: {
          "filter-applied": _vm.onFilterApplied,
          "filter-cleared": _vm.onFilterCleared,
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
        },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.transferRequests },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("dos.customer_transfers.columns.actions"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "router-link",
                          {
                            attrs: {
                              to: {
                                name: "DeviceTransfers",
                                params: { transfer_id: scope.row.id },
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$t(
                                    "dos.customer_transfers.columns.actions"
                                  )
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("dos.customer_transfers.columns.doorbot_id"),
                  prop: "doorbot_id",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("dos.customer_transfers.columns.mac_address"),
                  prop: "mac_address",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("dos.customer_transfers.columns.product"),
                  prop: "product",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("dos.customer_transfers.columns.old_owner"),
                  prop: "old_owner",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("dos.customer_transfers.columns.new_owner"),
                  prop: "new_owner",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("dos.customer_transfers.columns.status"),
                  prop: "status",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("dos.customer_transfers.columns.reason"),
                  prop: "reason",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("dos.customer_transfers.columns.start_date"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.formatDate(scope.row.start_date)) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("dos.customer_transfers.columns.end_date"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.formatDate(scope.row.end_date)) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("template", { slot: "empty" }, [
                _vm.isFiltered
                  ? _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("dos.customer_transfers.no_filter_results")
                        )
                      ),
                    ])
                  : _c("span", [
                      _vm._v(_vm._s(_vm.$t("dos.customer_transfers.empty"))),
                    ]),
              ]),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("router-view"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }